import React from "react";
import PropTypes from "prop-types";
import defer from "lodash/defer";
import { ButtonMenu, CallbackButton } from "./styled";
import { getNewSnippet, getNewAssessment, getNewMediaCarousel, getNewFileUpload } from "../Builder/helpers";
import { add } from "../actions";

const handleAdd = (dispatch, fn) => {
  dispatch(add(fn));
  defer(() => document.querySelector(".content-end").scrollIntoView({ behaviour: "smooth" }));
};

const AddNew = ({ title, isOverLimit, dispatch }) => {
  const menuItems = [
    {
      key: "add-new-submenu",
      label: title,
      popupOffset: [10, -10],
      disabled: isOverLimit,
      className: "addNewMenu",
      children: [
        { key: "snippet", label: <CallbackButton onClick={() => handleAdd(dispatch, getNewSnippet())}>Add New Snippet</CallbackButton> },
        { key: "assessment", label: <CallbackButton onClick={() => handleAdd(dispatch, getNewAssessment())}>Add New Assessment</CallbackButton> },
        { key: "multimedia", label: <CallbackButton onClick={() => handleAdd(dispatch, getNewMediaCarousel())}>Add New Multimedia</CallbackButton> },
        { key: "file", label: <CallbackButton onClick={() => handleAdd(dispatch, getNewFileUpload())}>Add New File Attachment</CallbackButton> },
      ],
    },
  ];

  return (
    <ButtonMenu selectable={false} items={menuItems} />
  );
};

AddNew.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]).isRequired,
  isOverLimit: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default AddNew;
